import { useEffect, useState } from 'react';

// stores react state in local storage
export function useLocalStorageState<ValueType>(defaultValue: ValueType, key: string, storeOnStateChange?: boolean) {

    const [value, setValue] = useState(() => {
        const stickyValue = window.localStorage.getItem(key);
        return stickyValue !== null
            ? JSON.parse(stickyValue)
            : defaultValue;
    });

    useEffect(() => {
        if (storeOnStateChange) {
            window.localStorage.setItem(key, JSON.stringify(value));
        }      
    }, [key, value]);

    return [value, setValue];
}